function initScrollTopEvents(){
	const scrollButton = document.getElementById("scroll-top");
	if( scrollButton ){
		// Return to page top on click
		scrollButton.addEventListener("click", () => {
			window.scroll({
				top: 0,
				left: 0,
				behavior: 'smooth'
			});
		});

		// Toggle button depending on scroll position
		window.addEventListener('scroll', () => {
			if(window.scrollY > 300) {
				scrollButton.classList.add('active');
			} else {
				scrollButton.classList.remove('active');
			}
		});
	}
}

export default initScrollTopEvents;